import { render, staticRenderFns } from "./BasketProduct.vue?vue&type=template&id=1307e5ec&scoped=true"
import script from "./BasketProduct.vue?vue&type=script&lang=js"
export * from "./BasketProduct.vue?vue&type=script&lang=js"
import style0 from "./BasketProduct.vue?vue&type=style&index=0&id=1307e5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307e5ec",
  null
  
)

export default component.exports